import http from "../../api";

export default {
  namespaced: true,
  actions: {
    getBalances() {
      return http.get("/Provider/Balances");
    },
    getCommissions() {
      return http.get("/Provider/Commissions");
    },
    getProviders() {
      return http.get("/Provider/List");
    },
    checkMonnify({}, reference) {
      console.log(reference);
      return http.get(`/Provider/check-monnify/${reference}`)
    }

  }
};



// WEBPACK FOOTER //
// ./src/store/modules/provider.js